/* eslint-disable */

/** unique or primary key constraints on table "argo.work_instruction" */
export enum ArgoWorkInstructionConstraint {
  /** unique or primary key constraint on columns "work_instruction_id" */
  ArgoWorkInstructionPkey = 'argo_work_instruction_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  ArgoWorkInstructionUniqueName = 'argo_work_instruction_unique_name'
}

/** select columns of table "argo.work_instruction" */
export enum ArgoWorkInstructionSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.work_instruction" */
export enum ArgoWorkInstructionUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

